import { Component, OnInit, OnDestroy } from '@angular/core';
import { AdalService } from 'adal-angular4';
import { Router, Route, NavigationEnd, NavigationCancel } from '@angular/router';
import { EnvironmentService } from '../environment-service/environment.service';
import { Subscription } from 'rxjs';
import { CountdownService } from '../services/countdown.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit, OnDestroy {

  public routes: Route[];
  public env: string;
  public currentLocation: string = 'Menu';

  // private user: adal.User;
  private reloadSubscription: Subscription;
  // private checkAuthSubscription: Subscription;

  constructor(
    private router: Router,
    private adalService: AdalService,
    private environmentService: EnvironmentService,
    private countdownService: CountdownService
  ) { }

  ngOnInit() {
    this.adalService.handleWindowCallback(false);

    console.log(this.adalService.userInfo);
    // this.checkAuthenticated();

    this.env = this.environmentService.getEnvironmentName().replace(/^\w/, c => c.toUpperCase());
    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd || val instanceof NavigationCancel) {

    //     this.adalService.handleWindowCallback(false);

        // determine current route
        let nextPath = (val as any).urlAfterRedirects;
        if (nextPath) {
          nextPath = nextPath.length === 0 ? '' : nextPath.substr(1);
        }
        const route = this.router.config.find(f => f.path === nextPath);

        if (this.reloadSubscription) { this.reloadSubscription.unsubscribe(); }

        // configure based on route data
        if (route && route.data) {
          this.currentLocation = route.data.title || 'Menu';
          if (route.data.autoReload) {
            // hard reload every few minutes (as configured) to clear memory leak due to the c3/d3 charts
            const randomTime: number = this.randomIntFromInterval(60 * route.data.autoReload.min, 60 * route.data.autoReload.max);
            this.reloadSubscription = this.countdownService.start('toolbar-reload-page', randomTime).subscribe(counter => {
              if (counter === 0) {
                window.location.reload(true);
              }
            });
          }
        }
        else {
          this.currentLocation = 'Menu';
        }    
      }
    });

    const userRoles: string[] = this.adalService.userInfo.profile.roles || [];
    this.routes = this.router.config.filter(route => 
      route.data && userRoles.some(userRole => 
        route.data.roles.some(role => role === userRole)) 
      );
  }

  ngOnDestroy() {
    if (this.reloadSubscription) { this.reloadSubscription.unsubscribe(); }
    // if (this.checkAuthSubscription) { this.checkAuthSubscription.unsubscribe(); }
  }

  // private checkAuthenticated() {
  //   if (this.checkAuthSubscription) { this.checkAuthSubscription.unsubscribe(); }
  //   this.checkAuthSubscription = this.countdownService.start('check-auth', 5).subscribe(val => {
  //     this.user = this.adalService.userInfo;
  //     if (val === 0) {
  //       this.adalService.handleWindowCallback(false);
  //       // check authentication
  //       if (this.user.authenticated && document.location.hash === '#/') {
  //         document.location.reload();
  //       } else {
  //         this.checkAuthenticated();
  //       }
  //     }
  //   });
  // }

  public login(): void {
    this.adalService.login();
  }

  public logout(): void {
    this.adalService.logOut();
  }

  get authenticated(): boolean {
    return this.adalService.userInfo.authenticated;
  }

  get user(): adal.User {
    return this.adalService.userInfo;
  }

  get displayName(): string {
    if (this.authenticated) {
      return `${this.user.profile.given_name} ${this.user.profile.family_name}`;
    }
    return '';
  }

  private randomIntFromInterval(min: number, max: number)
  {
      return Math.floor(Math.random() * (max - min + 1) + min);
  }
}